import { createAction, createSlice } from "@reduxjs/toolkit";

import listFactory from "../../../store/listFactory";

import type { APPLICATION_ENV } from "../../../constants/environment";
import type { ListSliceState } from "../../../store/helpers/list";
import type { UUID } from "../../../utils";
import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { Account } from "../models/Account";
import type { AccountPost } from "../models/AccountPost";

export interface FetchAccountPayload {
  customerId?: UUID | UUID[];
  environment?: APPLICATION_ENV;
}

export type UpdateAccountPayload = ObjectWithId & {
  data: Pick<Account, "nickname" | "bankName">;
};

const { slicePart, selectors } = listFactory<Account>("accounts");

export type AccountsSliceState = ListSliceState<
  Account,
  { item?: Account | null }
>;

export const initialState: AccountsSliceState = {
  ...slicePart.initialState,
  item: undefined,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
});

export const { setList, setItem, updateItem, addItem } = slice.actions;

export const fetchAccounts = createAction<FetchAccountPayload>("fetchAccounts");
export const fetchAccount = createAction<ObjectWithId>("fetchAccount");
export const createTempAccount = createAction("createTempAccount");
export const createAccount = createAction<AccountPost>("createAccount");
export const updateAccount = createAction<UpdateAccountPayload>(
  "updateAccount"
);
export const {
  selectList: selectAccounts,
  selectItem: selectAccount,
} = selectors;

export const accountsOperationPaths = (id?: UUID) => {
  return {
    listing: ["accounts", "listing"],
    details: ["accounts", "details", id],
    update: ["accounts", "update", id],
    create: ["accounts", "create"],
    setActiveFlag: ["accounts", "setActiveFlag", id],
  };
};

export default slice.reducer;
